module.exports = __webpack_public_path__ + "img/avatar-planet-happy.d6638dd2.svg";